import React, { useState } from "react"
import ReactDOM from "react-dom/client"
//import "@webcomponents/custom-elements/src/native-shim"
//import "@webcomponents/custom-elements"
import { RouterProvider } from "react-router-dom"
import router from "./routes/router"
import reportWebVitals from "./reportWebVitals"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Provider } from 'react-redux';
import { store } from './store';
import "./index.scss"
import Loading from "./components/Loading"
import { MsalProvider } from '@azure/msal-react';
import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { authConfig } from './config/constants/authConfig';

const msalInstance = new PublicClientApplication(authConfig.getMSALConfig());

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
	msalInstance.setActiveAccount(msalInstance.getActiveAccount());
}

msalInstance.addEventCallback((event: any) => {
	if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
		const account = event.payload.account;
		msalInstance.setActiveAccount(account);
	}
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
	//<React.StrictMode>
	<Provider store={store}>
		<MsalProvider instance={msalInstance}>
			<RouterProvider router={router} />
			<ToastContainer />
			<Loading />
		</MsalProvider>
	</Provider>
	//</React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
